import { ColorFacetComponentConfig, ColorFacetComponentModel, ColorFacetValue, HawkSearchComponents } from '@models';
import { BaseFacetComponent } from '../base-facet.component';
import defaultHtml from './color-facet.component.hbs';

export class ColorFacetComponent extends BaseFacetComponent<ColorFacetComponentConfig, ColorFacetComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'color-facet';
    protected override defaultHtml = defaultHtml;

    protected override renderContent(): boolean {
        return !!this.data;
    }

    protected override getContentModel(): ColorFacetComponentModel {
        const filterRegex = this.state.filter ? new RegExp(this.state.filter, 'i') : undefined;

        return {
            values:
                this.data!.values?.filter((c) => c.color).map(
                    (v, i): ColorFacetValue => ({
                        ...v,
                        visible:
                            (!filterRegex && (this.state.toggled || !this.data!.truncation || i < this.data!.truncation.threshold)) ||
                            (!!filterRegex && filterRegex.test(v.title ?? ''))
                    })
                ) ?? [],
            showToggle: !!this.data!.truncation && (this.data!.values?.length ?? 0) > this.data!.truncation.threshold && !this.state.filter,
            expanded: this.state.toggled ?? false,
            strings: {
                exclude: this.configuration?.strings?.exclude ?? 'Exclude',
                include: this.configuration?.strings?.include ?? 'Include',
                toggle: this.state.toggled ? this.configuration?.strings?.showFewer ?? 'Show fewer' : this.configuration?.strings?.showMore ?? 'Show more'
            }
        };
    }
}
